<div class="container">
    <div class="header">
        <div
            class="file-button"
            data-cy="mimics-files-button"
            [class.selected]="openingFileOptionDialog"
            (click)="openFilesOptionDialog($event)">
            <span class="button-name name">{{ 'mimic-folder.tab.file.button.text' | translate }}</span>
            <mat-icon svgIcon="dropdown-arrow" class="button-arrow-icon"></mat-icon>
        </div>
    </div>
    <div class="folder-list" data-cy="mimics-mimic-list">
        <div class="folder-item" *ngFor="let rootItem of rootList; index as i">
            <div class="folder-title" *ngIf="rootItem.type !== FOLDER_TYPE">
                <mat-icon class="button-arrow-icon"></mat-icon>
                <span
                    class="folder-name name"
                    data-cy="mimics-mimic-name"
                    [class.selected]="selectedMimic?.id === rootItem?.mimic?.id"
                    (click)="selectMimic(rootItem?.mimic)"
                    >{{ rootItem?.mimic?.name }}</span
                >
                <mat-icon
                    svgIcon="more-options"
                    class="more-option-icon"
                    data-cy="mimics-mimic-kebab-icon"
                    [class.opening]="currentMimic?.id === rootItem?.mimic?.id"
                    (click)="openMimicOptionDialog($event, rootItem?.mimic)"></mat-icon>
            </div>
            <div class="folder-title" *ngIf="rootItem.type === FOLDER_TYPE">
                <mat-icon
                    svgIcon="dropdown-arrow"
                    class="button-arrow-icon"
                    [class.expanded]="rootItem?.folder?.expanded"
                    (click)="openExpanded(rootItem?.folder?.id)"></mat-icon>
                <span class="folder-name name" (click)="openExpanded(rootItem?.folder?.id)">{{
                    rootItem?.folder?.name
                }}</span>
                <mat-icon
                    svgIcon="more-options"
                    class="more-option-icon"
                    [class.opening]="currentMimicFolder?.id === rootItem?.folder?.id"
                    (click)="openFolderOptionDialog($event, rootItem?.folder)"></mat-icon>
            </div>
            <div
                class="mimic-list"
                *ngIf="
                    rootItem?.folder?.expanded && rootItem.type === FOLDER_TYPE && rootItem?.folder?.mimicList.length
                ">
                <div class="mimic-item" *ngFor="let mimic of rootItem?.folder?.mimicList">
                    <span
                        class="mimic-name"
                        [class.selected]="selectedMimic?.id === mimic?.id"
                        (click)="selectMimic(mimic)"
                        >{{ mimic.name }}</span
                    >
                    <mat-icon
                        svgIcon="more-options"
                        class="more-option-icon"
                        [class.opening]="currentMimic?.id === mimic?.id"
                        (click)="openMimicOptionDialog($event, mimic)"></mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>
